<!-- eslint-disable -->
<template>
    <div class="results">
        <div class="">
            <h1 class="titre">{{ $t('incoming') }}</h1>
            <p><strong>{{ $t('ongoing') }}</strong></p>
        </div>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
    width : auto;
    text-align: center;
    font-size : 2.5em;
}
p{
    text-align: center;
    margin-top: 25px;
    font-family: Lato;
    font-size: 1.2em;
}
.titre{
    font-family: Rubik bold;
    letter-spacing: 0.05em;
    color: #193300; 
}
.card-body{
    margin-top : 70px;
}
.results{
    max-width: 800px;
    margin: 65px auto;
    padding: 100px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    text-align: center;

    /* width: 35%;
    height: 250px;
    margin-top : 75px;
    display : inline-block;
    align-items : center; */
}
</style>
